// extracted by mini-css-extract-plugin
export default {"slider":"Handle--slider--SzVAC"};